import { useQuery, UseQueryResult } from "react-query"
import { request } from "../util/request"

const ROOT_COMMENTS_PER_PAGE = 10

export function useComments(
  postId: number,
  page = 1,
  perPage = ROOT_COMMENTS_PER_PAGE,
  filter: string | null = null,
): UseQueryResult<unknown> {
  return useQuery(
    ["comments", postId, page, perPage, filter],
    getCommentsForPostId,
    {
      keepPreviousData: true,
    },
  )
}

export function useRepliesForParent(
  postId: number,
  parentId: number | null,
): UseQueryResult<unknown> {
  return useQuery(
    ["comments", "replies", postId, parentId],
    () =>
      request({
        queryKey: [
          "comments",
          {
            path: `/api/v1/posts/${postId}/comments.json`,
            params: { parent_id: parentId },
          },
        ],
      }),
    { enabled: !!parentId },
  )
}

const getCommentsForPostId = async ({ queryKey }: { queryKey: readonly unknown[] }) => {
  const [key, id, page, perPage, filter] = [...queryKey]
  return await request({
    queryKey: [
      key,
      {
        path: `/api/v1/posts/${id}/comments.json`,
        params: { per_page: perPage, page: page, filter: filter },
      },
    ],
  })
}
